var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flag-icon",class:_vm.flag.classes,attrs:{"title":_vm.flag.title}})
}
var staticRenderFns = []

export { render, staticRenderFns }